
import { useFollowStats } from "@/hooks/profile/useFollowStats";
import { useFollowersData } from "@/hooks/profile/useFollowersData";

export const useProfileStats = () => {
  const { followersCount, followingCount, loading } = useFollowStats();
  const { 
    followers, 
    following, 
    loadingFollowers, 
    loadingFollowing, 
    loadFollowers, 
    loadFollowing 
  } = useFollowersData();

  return {
    followersCount,
    followingCount,
    followers,
    following,
    loading,
    loadingFollowers,
    loadingFollowing,
    loadFollowers,
    loadFollowing
  };
};
